<div class="wrapper">
    <div
        id="container-settings-modal-close-button"
        class="close-modal-button"
        (click)="closeModal()"
        (mouseenter)="isCloseButtonHovered = true"
        (mouseleave)="isCloseButtonHovered = false"
    >
        <img
            [src]="
                'assets/svg/reusable-svg/close' +
                (isCloseButtonHovered ? '-hover' : '') +
                '.svg'
            "
            alt="close-icon"
        />
    </div>
    <div class="inner-wrapper">
        <div class="header-wrapper">
            <img
                src="assets/svg/reusable-svg/settings.svg"
                alt="settings-icon"
            />
            <span class="span-overflow-ellipsis-nowrap">
                {{
                    'containerSettings.header.' +
                    getTranslationPrefixByContainerType() | translate
                }}
            </span>
        </div>
        <div class="container-name-wrapper">
            <span
                *ngIf="!isNameEditingActive"
                class="span-overflow-ellipsis-nowrap"
            >{{ container.name }}</span
            >
            <div class="name-input-wrapper" *ngIf="isNameEditingActive">
                <input
                    #containerNameInput
                    id="container-settings-modal-container-name-edit-input"
                    type="text"
                    class="container-name-edit-input"
                    [formControl]="containerNameControl"
                    [class.invalid]="containerNameControl.invalid"
                    (keydown.enter)="saveNameChange()"
                    (keydown.escape)="discardNameChange()"
                    (blur)="saveNameChange()"
                />
                <app-display-errors
                    [control]="containerNameControl"
                    [translationKey]="
                        'containerSettings.nameInput.errorMessages.' +
                        getTranslationPrefixByContainerType()
                    "
                >
                </app-display-errors>
            </div>
            <img
                id="container-settings-modal-container-name-edit-input-activation-icon"
                src="assets/svg/reusable-svg/icon-rename.svg"
                alt="rename-icon"
                (click)="activateNameEditing()"
            />
        </div>
        <div class="container-collaboration-settings-wrapper">
            <app-container-collaboration-settings
                [visibilityOptions]="availableVisibilityOptions"
                [accessibilityOptions]="availableAccessibilityOptions"
                [selectedVisibility]="selectedVisibility"
                [selectedAccessibility]="selectedAccessibility"
                (visibilityChange)="onVisibilityChange($event)"
                (accessibilityChange)="onAccessibilityChange($event)"
            ></app-container-collaboration-settings>
        </div>
        <div class="description-and-image-container">
            <div class="description-wrapper">
                <span>{{
                        'containerSettings.textArea.header.' +
                        getTranslationPrefixByContainerType() | translate
                    }}</span>
                <div class="textarea-container">
                    <textarea
                        #textArea
                        maxlength="500"
                        class="description-textarea"
                        name="description"
                        id="containerDescriptionInput"
                        [placeholder]="
                            'containerSettings.textArea.placeholder.' +
                                getTranslationPrefixByContainerType()
                                | translate
                        "
                        [formControl]="containerDescriptionControl"
                        (blur)="saveTextAreaChanges()"
                        (keydown.escape)="discardTextAreaChanges()"
                    ></textarea>
                </div>
            </div>
            <div class="cover-image-wrapper">
                <span>{{
                        'containerSettings.coverImage.header' | translate
                    }}</span>
                <div class="image-container">
                    <div class="spinner-wrapper" *ngIf="showSpinner">
                        <div class="tryb-design-spinner"></div>
                    </div>
                    <app-container-image-upload
                        *ngIf="!showSpinner"
                        ($imageToUpload)="saveContainerImage($event)"
                        ($imageToDelete)="deleteContainerImage()"
                        [currentImage]="containerImage"
                    ></app-container-image-upload>
                </div>
            </div>
        </div>
        <div class="helper-text-wrapper">
            <span class="helper-test">{{
                    'containerSettings.textArea.helperText' | translate
                }}</span>
        </div>
    </div>
</div>
